export enum DATA_ITEM_CATEGORIES {
  CONTACT = 'CO',
  GENERAL = 'GI',
  NAVIGATION = 'NV',
  USER_ACCOUNT = 'UA',
}
